import { ActionTree, GetterTree, MutationTree } from "vuex";
import { AxiosError } from "axios";
import { RootState } from "@/models/store/RootState";
import { SnackbarState } from "@/models/store/SnackbarState";

export function processErrorMessage(error: AxiosError|string) {
  let errorMessage = "An error occurred";
  if (typeof error !== "string" && error && error.response && error.response.data) {
    const respMsg = error.response.data.message;
    const respError = error.response.data.errors;
    const respDetail = error.response.data.detail;

    if (respMsg && respMsg.length && !respError) {
      errorMessage = respMsg;
    } else if (respDetail || respError) {
      const respObj = respDetail || respError;
      const errorMessageArr: [] = [];
      // @ts-ignore
      Object.values(respObj).forEach((value) => errorMessageArr.push(value));
      errorMessage = errorMessageArr.toString();
    } else {
      errorMessage = error.response.statusText;
    }
  } else if (typeof error === "string" && error !== "") {
    errorMessage = error;
  }
  return errorMessage;
}

export const snackbarState = {
  message: "",
  show: false,
  type: ""
};

export const snackbarActions: ActionTree<SnackbarState, RootState> = {
  errorMessage: ({ commit }, error: AxiosError | string) => {
    if (typeof error === "string" || error.response) {
      commit("setMessage", processErrorMessage(error));
      commit("setType", "error");
      commit("showSnackbar");
    }
  },
  successMessage: ({ commit }, message: string) => {
    commit("setMessage", message);
    commit("setType", "success");
    commit("showSnackbar");
  },
  clearMessage: ({ commit }) => {
    commit("hideSnackbar");
  }
};

export const snackbarMutations: MutationTree<SnackbarState> = {
  setMessage: (state: SnackbarState, message: string) => {
    state.message = message;
  },
  setType: (state: SnackbarState, type: string) => {
    state.type = type;
  },
  hideSnackbar: (state: SnackbarState) => {
    state.show = false;
  },
  showSnackbar: (state: SnackbarState) => {
    state.show = true;
  }
};

export const snackbarGetters: GetterTree<SnackbarState, RootState> = {};

export default {
  name: "snackbar",
  namespaced: true,
  state: snackbarState,
  actions: snackbarActions,
  mutations: snackbarMutations,
  getters: snackbarGetters
};
